/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ITTFUploadModalScope extends ng.IScope {
        modalClose: () => void;
        modalSubmit: () => void;
        resource: string;
        file: string;
        dateshot: Date;
    }

    /**
     * TTFUploadModalController class
     */
    export class TTFUploadModalController {
        public static templateURL: string = "decorators/modals/ttf-upload-modal.html";
        public static ID: string = "#id-ttf-upload-modal";
        public static $name: string = "ttfUploadModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'resource', 'file'];

        private $scope: ITTFUploadModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: ITTFUploadModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    resource: string,
                    file: string) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.$scope.resource = resource;
            this.$scope.file = file;
            this.$scope.dateshot = new Date();
            this.close = close;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSubmit = (): void => {
                this.close(undefined);
            };
        }
    }
}
